<template>
  <div id="box">
    <Header></Header>
    <Menulist></Menulist>
    <div class="box_info">
      <!-- 用户信息卡片 -->
      <div class="user-info-card">
        <div class="user-info-left">
          <div class="user-avatar">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="user-details">
            <div class="user-company">{{ companyinfo.company || '未设置单位' }}</div>
            <div class="user-meta">
              <span class="meta-item meta-yscode">
                <i class="el-icon-office-building"></i>
                <span class="meta-label">信用代码</span>
                <span class="meta-value">{{ companyinfo.yscode || '-' }}</span>
              </span>
              <span class="meta-item meta-phone">
                <i class="el-icon-mobile-phone"></i>
                <span class="meta-label">手机号</span>
                <span class="meta-value">{{ companyinfo.phonenumber || '-' }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="user-actions">
          <el-button class="btn-edit" @click="editinfo">
            <i class="el-icon-edit"></i> 修改信息
          </el-button>
          <el-button class="btn-logout" @click="logout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-button>
        </div>
      </div>

      <!-- 左侧菜单 + 内容区 -->
      <div class="main-layout">
        <!-- 左侧菜单 -->
        <div class="sidebar-menu">
          <div class="menu-header">
            <i class="el-icon-menu"></i>
            <span>用户中心</span>
          </div>
          <div
            class="menu-item"
            :class="{ active: activeMenu === 'order' }"
            @click="activeMenu = 'order'"
          >
            <span>订单列表</span>
          </div>
          <div
            class="menu-item"
            :class="{ active: activeMenu === 'invoice' }"
            @click="activeMenu = 'invoice'"
          >
            <span>发票抬头</span>
          </div>
          <div
            class="menu-item"
            :class="{ active: activeMenu === 'record' }"
            @click="activeMenu = 'record'"
          >
            <span>开票记录</span>
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="content-area">
          <!-- 订单列表 -->
          <div v-show="activeMenu === 'order'" class="content-section">
            <div class="section-header">
              <i class="el-icon-document"></i>
              <span>订单列表</span>
              <span style="font-weight: normal;font-size: 12px">(支付完成订单请在3-5天点击开票记录，开票按钮。进行选择订单开票)</span>
            </div>
            <div class="section-body">
              <el-table
                :key="'tableKey'"
                :data="getlisdatas"
                border
                fit
                highlight-current-row
                style="width: 100%"
                stripe
                :header-cell-style="{  background:'#ddd',color:'#000000'}"
              >

              <el-table-column label="单位名称" align="center">
                <template slot-scope="{ row }">
                  <el-tooltip class="item" effect="dark" :content="row.company" placement="top-start">
                    <span>{{ row.company }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column label="信用代码" width="190" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.yscode }}</span>
                </template>
              </el-table-column>

              <el-table-column label="支付金额" width="100" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.totalfee }}</span>
                </template>
              </el-table-column>

              <el-table-column label="年限" width="80" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.totalnum }}</span>
                </template>
              </el-table-column>

              <el-table-column label="下单时间" width="180" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.addtime }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="订单类型" width="90">
                <template slot-scope="{ row }">
                  <span v-if="row.ordertype == 5" style="color: #E6A23C">网卡延期</span>
                  <span v-if="row.ordertype == 6" style="color:#409EFF">终端延期</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="支付方式" width="90">
                <template slot-scope="{ row }">
                  <span v-if="row.paymethod == 1" style="color: #E6A23C">线上办理</span>
                  <span v-if="row.paymethod == 2" style="color:#409EFF">线下办理</span>
                </template>
              </el-table-column>
<!--                return [0, 3, 6, 5, 8, 11].indexOf(status) > -1-->
              <el-table-column align="center" label="订单状态" width="120">
                <template slot-scope="{ row }">
                  <div class="li" v-if="row.status == 0 && row.paymethod == 1">已取消</div>
                  <div class="li" v-if="row.status == 1">支付中</div>
                  <div class="li" v-if="row.status == 2 && row.paymethod == 1">支付成功</div>
                  <div class="li" v-if="row.status == 3 && row.paymethod == 1">支付失败</div>
                  <div class="li" v-if="row.status == 4">已撤销</div>
                  <div class="li" v-if="row.status == 5">已退款</div>
                  <div class="li" v-if="row.status == 6">订单关闭</div>
                  <div class="li" v-if="row.status == 7">退款审核中</div>
                  <div class="li" v-if="row.status == 8">退款成功</div>
                  <div class="li" v-if="row.status == 9">退款失败</div>
                  <div class="li" v-if="row.status == 10">退款中</div>
                  <div class="li" v-if="row.status == 11">退款成功</div>
                  <div class="li" v-if="row.status == 12">退款失败</div>
                  <div class="li" v-if="row.status == 13">退款关闭</div>

                  <div class="li" v-if="row.status == 0 && row.paymethod == 2">待上传</div>
                  <div v-if="row.status == 14 && row.paymethod == 2">待审核</div>
                  <div v-if="row.status == 2 && row.paymethod == 2">审核成功</div>
                  <div v-if="row.status == 3 && row.paymethod == 2">审核失败</div>
                </template>
              </el-table-column>

              <!--  这块需要管理员权限     -->
              <el-table-column align="center" fixed="right" class-name="small-padding" label="操作" width="350" >
                <template slot-scope="{ row, $index }">
                  <el-button plain size="mini" type="warning" @click="chakanLookstatus(row)">查看</el-button>
                  <el-button plain size="mini" v-if="!row.sealUrl" type="success" @click="generateAcontract(row)">生成合同</el-button>
                  <el-button plain size="mini" v-if="row.sealUrl" type="success" @click="previewContract(row)">预览合同</el-button>
                  <el-button plain size="mini" v-if="row.sealUrl" type="primary" @click="downloadContract(row)">下载合同</el-button>
                  <el-button plain size="mini" v-if="row.originalserialno" type="warning" @click="viewInvoicePdf(row)">查看发票</el-button>
                  <!-- 仅「未支付成功」或「已退款成功」的订单可删除 -->
                  <el-button plain size="mini" type="danger" v-if="canDeleteOrder(row)" @click="chakandetele(row)">删除</el-button>
                  <el-upload
                      v-if="row.status == 0 && row.paymethod == 2 || row.status == 3 && row.paymethod == 2"
                      :headers="headers"
                      class="upload-demo"
                      :action="actionurl"
                      :data="updatedata"
                      :on-exceed="handleExceed"
                      :limit="1"
                      accept=".png,.jpg"
                      :on-success="handleuploadSuccess"
                      :before-upload="beforeupload"
                      :show-file-list="false"
                      :file-list="fileList">
                    <el-button type="primary" plain size="mini"  @click="updataphone(row.id)" style="margin-top: 10px">上传支付凭证</el-button>
                  </el-upload>
                </template>
              </el-table-column>
            </el-table>
            </div>
            <div style="display: flex;justify-content: flex-end;background: #fff;padding: 15px 20px;">
              <pagination v-if="total > 0" :limit.sync="listQuery.pagesize" :page.sync="listQuery.page" :total="total" @pagination="getlist"/>
            </div>
          </div>

          <!-- 发票抬头 -->
          <div v-if="activeMenu === 'invoice'" class="content-section">
            <div class="section-header">
              <i class="el-icon-tickets"></i>
              <span>发票抬头</span>
              <el-button type="primary" class="btn-add-title" @click="showAddInvoiceTitle">
                <i class="el-icon-plus"></i> 新增抬头
              </el-button>
            </div>
            <div class="invoice-body">
              <el-table
                :data="invoiceTitleList"
                border
                fit
                highlight-current-row
                style="width: 100%"
                v-loading="invoiceTitleLoading"
              >
                <el-table-column label="单位名称" align="center" min-width="180">
                  <template slot-scope="{ row }">
                    <span>{{ row.subject }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="信用代码" min-width="160" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.yscode }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="收件邮箱" min-width="190" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.email }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="联系方式" width="120" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.phone }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="开户银行" min-width="200" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.bank || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="银行账号" min-width="160" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.bankNum || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="150" align="center" fixed="right">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="small" @click="editInvoiceTitle(row)">
                      <i class="el-icon-edit"></i> 编辑
                    </el-button>
                    <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteInvoiceTitle(row)">
                      <i class="el-icon-delete"></i> 删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 开票记录 -->
          <div v-if="activeMenu === 'record'" class="content-section">
            <div class="section-header">
              <i class="el-icon-document-checked"></i>
              <span>开票记录</span>
              <el-button type="primary" class="btn-add-title" @click="clickshowAddInvoiceTitle">开票</el-button>
            </div>
            <div class="invoice-body">
              <el-table
                :data="invoiceRecordList"
                border
                fit
                highlight-current-row
                style="width: 100%"
                v-loading="invoiceRecordLoading"
              >
                <el-table-column label="发票抬头" align="center" min-width="180">
                  <template slot-scope="{ row }">
                    <span>{{ row.header }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="信用代码" width="180" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.yscode }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="邮箱" width="180" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.email }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="开户行" width="150" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.bank || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="银行账号" width="180" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.bankNum || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="状态" width="100" align="center">
                  <template slot-scope="{ row }">
                    <el-tag v-if="row.status === 1" type="warning">待开票</el-tag>
                    <el-tag v-else-if="row.status === 2" type="success">已开票</el-tag>
                    <el-tag v-else type="danger">未知</el-tag>
                  </template>
                </el-table-column>

                <el-table-column label="审核状态" width="100" align="center">
                  <template slot-scope="{ row }">
                    <el-tag v-if="row.auditstatus == 1" type="warning">待审核</el-tag>
                    <el-tag v-else-if="row.auditstatus == 2" type="success">审核通过</el-tag>
                    <el-tag v-else-if="row.auditstatus == 3" type="danger">审核失败</el-tag>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="150" align="center" fixed="right">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="small" @click="editInvoiceRecordlook(row)">查看</el-button>
<!--                    <el-button type="text" v-if="row.status == 2" size="small" @click="editInvoiceRecordlook(row)">查看发票</el-button>-->
                    <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteInvoiceRecord(row)">删除</el-button>
                    <el-button v-if="row.auditstatus == 3" type="text" size="small" style="color:#E6A23C;" @click="ClickreviewdialogVisible(row)">原因</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <div class="pagination-wrapper" v-if="invoiceRecordTotal > 0">
                <el-pagination
                  @current-change="handleInvoiceRecordPageChange"
                  :current-page.sync="invoiceRecordPage"
                  :page-size="invoiceRecordPageSize"
                  layout="total, prev, pager, next"
                  :total="invoiceRecordTotal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="驳回原因" :visible.sync="reviewdialogVisible" width="30%" >
      <p>{{ reviewdialogVisibletext }}</p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewdialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="invoiceTitleModalTitle" :visible.sync="invoiceTitleModalVisible" width="600px">
      <el-form
        ref="invoiceTitleForm"
        :model="invoiceTitleForm"
        :rules="invoiceTitleRules"
        label-width="100px"
        class="invoice-title-form"
      >
        <el-form-item label="单位名称" prop="subject">
          <el-autocomplete
            v-model="invoiceTitleForm.subject"
            :fetch-suggestions="handleCompanySearch"
            placeholder="请输入单位名称，支持搜索选择，搜索不到可自行输入"
            style="width: 100%;"
            clearable
            @select="handleCompanySelect"
            @blur="handleCompanyBlur"
          >
            <template slot-scope="{ item }">
              <div class="company-search-item">
                <div class="company-search-name">{{ item.name }}</div>
                <div class="company-search-code">信用代码: {{ item.taxId }}</div>
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="信用代码" prop="yscode">
          <el-input v-model="invoiceTitleForm.yscode" placeholder="请输入统一社会信用代码" />
        </el-form-item>
        <el-form-item label="收件邮箱" prop="email">
          <el-input v-model="invoiceTitleForm.email" placeholder="请输入收件邮箱" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="invoiceTitleForm.phone" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="单位地址">
          <el-input v-model="invoiceTitleForm.address" placeholder="请输入单位地址" />
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="invoiceTitleForm.bank" placeholder="请输入开户银行" />
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="invoiceTitleForm.bankNum" placeholder="请输入银行账号" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceTitleModalVisible = false">取 消</el-button>
        <el-button type="primary" :loading="invoiceTitleSubmitting" @click="submitInvoiceTitle">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialogVisibleDetails" width="90%">
      <el-row :gutter="20">
        <el-col :span="invoicelist.length == 0 && dakuanimgurl == '' ? 24 : 16">
          <el-divider content-position="center">使用单位信息</el-divider>
          <el-card class="box-card">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="box_list">
                  <div class="box_list_title">单位名称：</div>
                  <div class="box_list_content">{{orderinfo.company}}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="box_list">
                  <div class="box_list_title">信用代码：</div>
                  <div class="box_list_content">{{orderinfo.yscode}}</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="box_list">
                  <div class="box_list_title">联系人：</div>
                  <div class="box_list_content">{{orderinfo.name}}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="box_list">
                  <div class="box_list_title">联系方式：</div>
                  <div class="box_list_content">{{orderinfo.phone}}</div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-divider content-position="center">订单信息</el-divider>
            <el-card class="box-card">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">订单号：</div>
                    <div class="box_list_content">{{orderinfo.id}}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">购买时间：</div>
                    <div class="box_list_content">{{orderinfo.addtime}}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">订单状态：</div>
                    <div class="box_list_content">
                      <div v-if="orderinfo.status == 0">订单生成</div>
                      <div v-if="orderinfo.status == 1">支付中</div>
                      <div v-if="orderinfo.status == 2 && orderinfo.paymethod == 1">支付成功</div>
                      <div v-if="orderinfo.status == 3 && orderinfo.paymethod == 1">支付失败</div>
                      <div v-if="orderinfo.status == 4">已撤销</div>
                      <div v-if="orderinfo.status == 5">已退款</div>
                      <div v-if="orderinfo.status == 6">订单关闭</div>
                      <div v-if="orderinfo.status == 7">退款审核中</div>
                      <div v-if="orderinfo.status == 8">退款成功</div>
                      <div v-if="orderinfo.status == 9">退款失败</div>
                      <div v-if="orderinfo.status == 10">退款中</div>
                      <div v-if="orderinfo.status == 11">退款成功</div>
                      <div v-if="orderinfo.status == 12">退款失败</div>
                      <div v-if="orderinfo.status == 13">退款关闭</div>

                      <div v-if="orderinfo.status == 14 && orderinfo.paymethod == 2">待审核</div>
                      <div v-if="orderinfo.status == 2 && orderinfo.paymethod == 2">审核成功</div>
                      <div v-if="orderinfo.status == 3 && orderinfo.paymethod == 2">审核失败</div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">购买年限：</div>
                    <div class="box_list_content">{{orderinfo.totalnum}}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">购买单价：</div>
                    <div class="box_list_content"> {{ orderinfo.price}}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="box_list">
                    <div class="box_list_title">消费金额：</div>
                    <div class="box_list_content"> {{ orderinfo.totalfee}}</div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          <el-divider content-position="center">列表信息</el-divider>
          <div v-if="orderinfo.ordertype == 5">
            <el-table
                :key="'tableKey'"
                :data="datas"
                border
                fit
                highlight-current-row
                style="width: 100%"
                stripe
                :header-cell-style="{  background:'#ddd',color:'#000000'}"
            >
              <el-table-column label="单位名称" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.ybdept }}</span>
                </template>
              </el-table-column>

              <el-table-column label="信用代码" width="190" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.yscode }}</span>
                </template>
              </el-table-column>

              <el-table-column label="ICCID(卡号)" width="200" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.iccid }}</span>
                </template>
              </el-table-column>

              <el-table-column label="终端医保SN" width="200" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.ybsn }}</span>
                </template>
              </el-table-column>

              <el-table-column label="终端设备SN" width="200" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.sn }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="orderinfo.ordertype == 6">
            <el-table
                :key="'tableKey'"
                :data="datas"
                border
                fit
                highlight-current-row
                style="width: 100%"
                stripe
                :header-cell-style="{  background:'#ddd',color:'#000000'}"
            >
              <el-table-column label="终端名称" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.title }}</span>
                </template>
              </el-table-column>

              <el-table-column label="型号" width="190" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.model }}</span>
                </template>
              </el-table-column>


              <el-table-column label="终端医保SN" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.ybsn }}</span>
                </template>
              </el-table-column>

              <el-table-column label="终端设备SN"  align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.sn }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </el-col>
        <el-col :span="invoicelist.length != 0 || dakuanimgurl != '' ? 8 : 0">
          <div v-if="orderinfo.paymethod == 2 && orderinfo.paymentvoucher != ''">
            <el-divider content-position="center">付款凭证</el-divider>
            <el-timeline :reverse="reverses">
              <el-card v-for="(activity,index) in srcList" style="border-radius:5rpx">
                <div slot="header" class="clearfix">
                  <b>线下付款凭证</b>
                </div>
                <el-image style="width: 200px; max-height: 200px;margin: 0 auto;" :src="dakuanimgurl" :preview-src-list="srcList" :fit="contain"></el-image>
                <el-upload
                    v-if="dakuanimgurl != '' && ((orderinfo.status != 2 && orderinfo.paymethod != 1) || (orderinfo.status != 2 && orderinfo.paymethod != 2))"
                    :headers="headers"
                    class="upload-demo"
                    :action="actionurl"
                    :data="updatedata"
                    :on-exceed="handleExceed"
                    :limit="1"
                    accept=".png,.jpg"
                    :on-success="handleuploadSuccess"
                    :before-upload="beforeupload"
                    :show-file-list="false"
                    :file-list="fileList">
                  <el-button type="text" plain size="mini"  @click="updataphone(orderinfo.id)" style="margin-top: 10px">传错了？重新上传</el-button>
                </el-upload>
              </el-card>
            </el-timeline>
          </div>
          <div v-if="invoicelist.length != 0">
            <el-divider content-position="center">发票信息</el-divider>
            <el-timeline :reverse="reverse">
              <el-card class="box-card" v-for="(activity, index) in invoicelist">
                <div slot="header" class="clearfix">
                  <b>发票信息</b>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="Downloadinvoicexiazai(activity,index)">下载发票</el-button>
                </div>
<!--                <div style="height: 40px;line-height: 40px"> 单位名称：{{activity.subject}} </div>-->
                <el-image v-if="activity.img != ''" style="width: 200px; max-height: 200px;margin: 0 auto;" :src="activity.img" :preview-src-list="activity.imglist" :fit="contain"></el-image>
              </el-card>
            </el-timeline>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDetails = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDetails = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="申请开票" :visible.sync="Invoicerequeststatus" width="50%" >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="subject">
              <el-input v-model="ruleForm.subject"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码" prop="yscode">
              <el-input v-model="ruleForm.yscode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注意事项" prop="name">
             <span>注：请不要填写企业内部邮箱！</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item style="display: flex;justify-content: flex-end;">
          <el-button @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">立即申请</el-button>
        </el-form-item>
      </el-form>

<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
<!--        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
<!--      </span>-->
    </el-dialog>
    <!-- 申请开票弹窗 -->
    <el-dialog
      title="申请开票"
      :visible.sync="invoiceModalVisible"
      width="600px"
    >
      <div v-loading="invoiceModalLoading">
        <!-- 已选订单信息 -->
        <div class="invoice-section">
          <h4 class="section-subtitle">
            <i class="el-icon-document-checked"></i> 已选订单 ({{ selectedOrderIds.length }}个)
          </h4>
          <div class="selected-orders">
            <div v-for="orderId in selectedOrderIds" :key="orderId" class="order-tag">
              <el-tag size="small" type="info">订单号: {{ orderId }}</el-tag>
            </div>
          </div>
        </div>

        <!-- 发票抬头选择 -->
        <div class="invoice-section">
          <h4 class="section-subtitle">
            <i class="el-icon-office-building"></i> 选择发票抬头
          </h4>
          <el-radio-group v-model="selectedInvoiceTitleId" style="width: 100%;">
            <div class="invoice-title-list">
              <el-radio
                v-for="item in invoiceTitleList"
                :key="item.id"
                :label="item.id"
                class="invoice-title-item"
              >
                <div class="title-info">
                  <span class="title-name">{{ item.subject }}</span>
                  <span class="title-code">{{ item.yscode }}</span>
                </div>
              </el-radio>
              <div v-if="invoiceTitleList.length === 0" class="empty-tips">
                <i class="el-icon-info"></i> 暂无发票抬头，请先添加
              </div>
            </div>
          </el-radio-group>
        </div>

        <!-- 发票类型选择 -->
        <div class="invoice-section">
          <h4 class="section-subtitle">
            <i class="el-icon-document"></i> 选择发票类型
          </h4>
          <el-radio-group v-model="invoiceType">
            <el-radio :label="1">增值税普通发票</el-radio>
            <el-radio :label="2">增值税专用发票</el-radio>
          </el-radio-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceModalVisible = false">取 消</el-button>
        <el-button type="primary" :loading="invoiceModalLoading" @click="submitInvoice">确 定</el-button>
      </span>
    </el-dialog>
    <!--  选择开票  -->
    <el-dialog title="选择开票" :visible.sync="invoicestatus" width="80%" >
      <div class="section-header">
        <i class="el-icon-tickets"></i>
        <span>开票</span>
        <a-button v-if="selectedOrderKeys.length != 0" type="primary" class="btn-add-title" @click="invoice(1,1)">开票</a-button>
      </div>
      <a-table :columns="scolumns" :row-key="record => record.id" :data-source="sdatas" :pagination="pagination" :loading="loading" :bordered="true" @change="handleTableChange" :row-selection="{ selectedRowKeys: selectedOrderKeys, onChange: onSelectOrderChange }">
        <template slot="company" slot-scope="datas, record">
          <a-tooltip placement="top"  style="width:180;">
            <template slot="title"> <span>{{record.company}}</span> </template>
            <span style="display:block;width: 100px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{record.company}}</span>
          </a-tooltip>
        </template>


        <template slot="yscode" slot-scope="datas, record">
          <a-tooltip placement="top" style="width:180;">
            <template slot="title"> <span>{{record.yscode}}</span> </template>
            <span style="display:block;width: 100px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{record.yscode}}</span>
          </a-tooltip>
        </template>

        <template slot="totalfee" slot-scope="datas, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ record.totalfee }}</span> </template>
            <span style="display:block;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{  record.totalfee }}</span>
          </a-tooltip>
        </template>

        <template slot="addtime" slot-scope="datas, record">
          <a-tooltip placement="top"  style="width:100;">
            <template slot="title"> <span>{{record.addtime}}</span> </template>
            <span style="display:block;width: 100px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{record.addtime}}</span>
          </a-tooltip>
        </template>

<!--        <template slot="sactions" slot-scope="datas, record">-->
<!--          <span>开票</span>-->
<!--        </template>-->

        <template slot="ordertype" slot-scope="datas, record">
          <span v-if="record.ordertype == 5" style="color: #E6A23C">网卡延期</span>
          <span v-if="record.ordertype == 6" style="color:#409EFF">终端延期</span>
        </template>

        <template slot="actions" slot-scope="datas, record">
          <div class="li" v-if="record.status == 0">待支付</div>
          <div class="li" v-if="record.status == 1">支付中</div>
          <div class="li" v-if="record.status == 2">支付成功</div>
          <div class="li" v-if="record.status == 3">支付失败</div>
          <div class="li" v-if="record.status == 4">已撤销</div>
          <div class="li" v-if="record.status == 5">已退款</div>
          <div class="li" v-if="record.status == 6">订单关闭</div>
          <div class="li" v-if="record.status == 7">退款审核中</div>
          <div class="li" v-if="record.status == 8">退款成功</div>
          <div class="li" v-if="record.status == 9">退款失败</div>
          <div class="li" v-if="record.status == 10">退款中</div>
          <div class="li" v-if="record.status == 11">退款成功</div>
          <div class="li" v-if="record.status == 12">退款失败</div>
          <div class="li" v-if="record.status == 13">退款关闭</div>
        </template>

        <template slot="action" slot-scope="datas, record">
          <a href="javascript:;" v-if="record.status == 2" @click="invoice(record,0)">开票</a>
        </template>

      </a-table>
    </el-dialog>
    <!-- 开票记录详情弹窗 -->
    <el-dialog
      title="记录详情"
      :visible.sync="invoiceRecordDetailVisible"
      width="80%"
      class="invoice-detail-dialog"
    >
      <!-- 开票信息 -->
      <div class="detail-section">
        <div class="detail-section-title">
          <span class="section-line"></span>
          <span>开票信息</span>
        </div>
        <div class="detail-info-content">
          <el-row :gutter="40">
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">发票抬头：</span>
                <span class="info-value">{{ invoiceRecordDetail.header }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">信用代码：</span>
                <span class="info-value">{{ invoiceRecordDetail.yscode }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">发票类型：</span>
                <el-tag size="small" type="warning" v-if="invoiceRecordDetail.invoiceType == 2">专票</el-tag>
                <el-tag size="small" type="success" v-else>普票</el-tag>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">邮箱：</span>
                <span class="info-value">{{ invoiceRecordDetail.email }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">开户行：</span>
                <span class="info-value">{{ invoiceRecordDetail.bank || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">银行账号：</span>
                <span class="info-value">{{ invoiceRecordDetail.bankNum || '-' }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="16">
              <div class="info-row">
                <span class="info-label">地址：</span>
                <span class="info-value">{{ invoiceRecordDetail.address || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-row">
                <span class="info-label">状态：</span>
                <el-tag size="small" type="warning" v-if="invoiceRecordDetail.status === 1">待开票</el-tag>
                <el-tag size="small" type="success" v-else-if="invoiceRecordDetail.status === 2">已开票</el-tag>
                <el-tag size="small" type="info" v-else>未知</el-tag>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 关联订单 -->
      <div class="detail-section">
        <div class="detail-section-title">
          <span class="section-line"></span>
          <span>关联订单</span>
        </div>
        <div class="detail-table-content">
          <el-table
            :data="invoiceRecordDetailOrders"
            border
            fit
            highlight-current-row
            style="width: 100%"
            max-height="400"
          >
            <el-table-column label="单位名称" align="center" min-width="150">
              <template slot-scope="{ row }">
                <span>{{ row.company }}</span>
              </template>
            </el-table-column>
            <el-table-column label="信用代码" align="center" width="180">
              <template slot-scope="{ row }">
                <span>{{ row.yscode }}</span>
              </template>
            </el-table-column>
            <el-table-column label="年限" align="center" width="100">
              <template slot-scope="{ row }">
                <span>{{ row.totalnum || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="消费金额" align="center" width="120">
              <template slot-scope="{ row }">
                <span>{{ row.totalfee }}</span>
              </template>
            </el-table-column>
            <el-table-column label="联系人" align="center" width="100">
              <template slot-scope="{ row }">
                <span>{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="联系电话" align="center" width="130">
              <template slot-scope="{ row }">
                <span>{{ row.phone }}</span>
              </template>
            </el-table-column>
            <el-table-column label="订单类型" align="center" width="100">
              <template slot-scope="{ row }">
                <span v-if="row.ordertype == 5" style="color: #E6A23C">网卡延期</span>
                <span v-else-if="row.ordertype == 6" style="color:#409EFF">终端延期</span>
                <span v-else-if="row.ordertype == 1" style="color: #409EFF">KEY订单</span>
                <span v-else-if="row.ordertype == 2" style="color: #67C23A">制图服务</span>
                <span v-else-if="row.ordertype == 3" style="color: #E6A23C">服务续费</span>
                <span v-else-if="row.ordertype == 4" style="color: #E6A23C">人工制图</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="购买时间" align="center" width="160">
              <template slot-scope="{ row }">
                <span>{{ row.addtime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="viewInvoicePdfByOrder(row)">查看发票</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceRecordDetailVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 发票 PDF 查看弹窗 -->
    <el-dialog title="发票查看" :visible.sync="invoicePdfVisible" width="60%" :before-close="closeInvoicePdf">
      <div class="invoice-pdf-container" v-if="invoicePdfUrl">
        <iframe :src="invoicePdfUrl" width="100%" height="600px" frameborder="0"></iframe>
      </div>
      <div v-else class="invoice-empty">
        <i class="el-icon-document-delete"></i>
        <p>暂无发票文件</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeInvoicePdf">关 闭</el-button>
        <el-button v-if="invoicePdfUrl" type="success" @click="downloadInvoicePdf">下 载</el-button>
      </span>
    </el-dialog>
    <!-- 合同预览弹窗 -->
    <el-dialog title="合同预览" :visible.sync="contractPreviewVisible" width="70%" :before-close="closeContractPreview" v-loading="contractPreviewLoading" element-loading-text="合同加载中...">
      <div class="invoice-pdf-container" v-if="contractPreviewUrl">
        <iframe :src="contractPreviewUrl" width="100%" height="600px" frameborder="0"></iframe>
      </div>
      <div v-else-if="!contractPreviewLoading" class="invoice-empty">
        <i class="el-icon-document-delete"></i>
        <p>暂无合同文件</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeContractPreview">关 闭</el-button>
        <el-button v-if="contractPreviewUrl" type="success" @click="downloadContractByUrl">下 载</el-button>
      </span>
    </el-dialog>

    <Footer></Footer>
  </div>
</template>

<script>
import {
  getInfo,
  mail_send,
  mallOrderdata_apply_refund,
  mallOrderdata_deal_seal_list,
  mallOrderdata_delete_mallOrderdata,
  cardInvoice_Add_cardInvoice,
  order_orderlist,
  order_applyContract,
  SF_query_by_expressno,
  mallOrderdata_download_seal,
  card_selectlist,
  terminal_selectlist,
  cardInvoice_CardInvoiceList, miniodownload, mallOrderdata_selectlist,
  invoiceTitle_selectlist,
  invoiceTitle_add,
  invoiceTitle_update,
  invoiceTitle_delete,
  orderInvoice_selectlist,
  orderInvoice_add,
  orderInvoice_update,
  orderInvoice_delete,
  company_search,
  invoice_query
} from '@/api/manage' // 接口
import {Carousel} from 'ant-design-vue'
import PayTestModal from "./PayModal"; // 二维码对话框组件
import Pagination from '@/components/Pagination'
import Header from "@/components/heard/index.vue";
import Footer from "@/components/footer/index.vue";
import {getToken, removeToken} from "@/utils/auth";
import img from "@/assets/shili.png";
import jianceimg from "@/assets/key_images.png";
import userimg from "@/assets/user/userimg.png";

import PayTestBarCode from "@/views/seal/PayBarCode.vue";
import Menulist from "@/components/menulist/index.vue";


export default {
  name: 'paytest',
  props: {},
  components: {Menulist, PayTestModal, PayTestBarCode, Carousel, Pagination, Header, Footer},
  data() {
    return {
      reviewdialogVisible:false,
      reviewdialogVisibletext:'',
      invoicePdfVisible: false,
      invoicePdfUrl: '',
      contractPreviewVisible: false,
      contractPreviewUrl: '',
      contractFileName: '',
      contractPreviewLoading: false,
      activeMenu: 'order', // 当前选中的菜单
      // 发票抬头相关数据
      invoiceTitleList: [],
      invoiceTitleLoading: false,
      invoiceTitleModalVisible: false,
      invoiceTitleModalTitle: '新增发票抬头',
      invoiceTitleSubmitting: false,
      // 单位名称搜索相关
      companySearchOptions: [],
      companySearchList: [],
      invoiceTitleForm: {
        id: null,
        subject: '',
        yscode: '',
        email: '',
        phone: '',
        address: '',
        bank: '',
        bankNum: ''
      },
      invoiceTitleRules: {
        subject: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        yscode: [{ required: true, message: '请输入信用代码', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入收件邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        phone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }]
      },
      // 开票记录相关数据
      invoiceRecordList: [],
      invoiceRecordLoading: false,
      invoiceRecordPage: 1,
      invoiceRecordPageSize: 10,
      invoiceRecordTotal: 0,
      // 开票记录详情弹窗
      invoiceRecordDetailVisible: false,
      invoiceRecordDetail: {},
      invoiceRecordDetailOrders: [],
      // 开票弹窗
      invoiceModalVisible: false,
      invoiceModalLoading: false,
      selectedInvoiceTitleId: null,
      invoiceType: 1, // 1-普票 2-专票
      selectedOrderIds: [],
      // 订单选择弹窗
      invoicestatus: false,
      selectedOrderKeys: [],
      contain:['contain'],
      tutulist:[{}],
      srcList:[],
      dakuanimgurl:'',
      getlisdatas:[],
      listQuery:{
        ordertypes:'5,6',
        pagesize:10,
        page:1,
        yscode:'',
        orgcode:'',
      },
      total:0,
      userimg:userimg,
      companyinfostatus:true,
      jianceimg:jianceimg,
      current: ["ukey"],
      sssvisiblesss: true,
      visiblemodd: false,
      // urlop:'images/93750.png',
      totalnum: 1,
      checked1: false,
      form: this.$form.createForm(this, {name: "coordinated"}),
      dialogStyle: {
        top: "40%",
      },
      dialogVisiblesss: false,
      phone: '',
      expressno:'',
      phonelist:[],
      Downloadstatus:false,
      headers: { Authorization: "Bearer " + localStorage.getItem("setToken") ,appid:CONFIG.appid},
      updatedata: {  uploadtype: "document",id:''},
      actionurl:'',
      orderinfo:'',
      fileList: [],
      fileLists: [],
      dialogVisibleDetails:false,
      nowcompany: '',
      nowemail: '',
      listLoading: false,
      textarea: '',
      yscode: '',
      dialogVisible:false,
      sdisableds: false,
      timer: 60,
      mailbox: '',
      mailboxcode: '',
      datas: [],
      loading: false,
      reverse: true,
      reverses:true,
      invoicelist: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
    // {
    //   title: 'ID',
    //       align: "center",
    //     dataIndex: 'id',
    // },
      sdatas:[],
      scolumns: [
        {
          title: '单位名称',
          dataIndex: 'company',
          align: "center",
          scopedSlots: { customRender: "company" },
        },
        {
          title: '信用代码',
          dataIndex: 'yscode',
          align: "center",
          scopedSlots: { customRender: "yscode" },
        },
        {
          title: '数量',
          align: "center",
          dataIndex: 'totalnum'
        },
        {
          title: '消费金额',
          align: "center",
          dataIndex: 'totalfee',
          scopedSlots: { customRender: "totalfee" },
        },
        {
          title: '购买时间',
          dataIndex: 'addtime',
          align: "center",
          scopedSlots: { customRender: "addtime" },
        },
        {
          title: '订单类型',
          key: 'ordertype',
          align: "center",
          scopedSlots: {customRender: 'ordertype'},
        },
        {
          title: '状态',
          key: 'actions',
          align: "center",
          scopedSlots: {customRender: 'actions'},
        },
        {
          title: '操作',
          key: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},

        }
      ],
      columns: [
        {
          title: '单位名称',
          dataIndex: 'company',
          align: "center",
          scopedSlots: { customRender: "company" },
        },
        {
          title: '信用代码',
          dataIndex: 'yscode',
          align: "center",
          scopedSlots: { customRender: "yscode" },
        },
        {
          title: '购买数量',
          align: "center",
          dataIndex: 'totalnum'
        },
        {
          title: '消费金额',
          align: "center",
          dataIndex: 'totalfee',
          scopedSlots: { customRender: "totalfee" },
        },
        {
          title: '购买时间',
          dataIndex: 'addtime',
          align: "center",
          scopedSlots: { customRender: "addtime" },
        },
        {
          title: '联系人',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: '联系电话',
          align: "center",
          dataIndex: 'phone'
        },
        {
          title: '是否开票',
          key: 'sactions',
          align: "center",
          scopedSlots: {customRender: 'sactions'},
        },
        {
          title: '订单类型',
          key: 'ordertype',
          align: "center",
          scopedSlots: {customRender: 'ordertype'},
        },
        {
          title: '状态',
          key: 'actions',
          align: "center",
          scopedSlots: {customRender: 'actions'},
        },
        {
          title: '操作',
          key: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},

        }
      ],
      pattern: '/^\\w+((-\\w+)|(\\.\\w+))*@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$/',
      imgurl: require('@/assets/images/key.png'),
      imgbg: require('@/assets/images/topbg.jpeg'),
      mchAppList: [], // app列表
      appId: '2021003131636388', // 已选择的appId
      appPaywayList: ['ALI_QR'], // 商户app支持的支付方式
      currentWayCode: 'ALI_QR', // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: '', // 支付参数
      mchOrderNo: '', // 模拟商户订单号
      authCode: '', // 条码的值
      companyyscode: '',
      paytestAmount: '0.01', // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: '接口调试', // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabledlook: false,
      activities:[],
      visibletongzhi: false,
      visiblelook: false,
      valueaw: 2,
      valiBtn: '同意条款',
      ModalText: '阅读协议，哈哈首科大厦大家安康',
      visible: false,
      companyname: '',
      confirmLoading: false,
      radioStyle: {
        cursor: 'pointer',
        marginleft: '10px',
        height: '30px',
        lineHeight: '30px',
        color: '#132b75',
      },
      page: 1,
      pagesize: 10,
      mpd: null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonum: null,
      Byyouji: null,
      number: {
        value: 11,
      },
      ID:'',
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      projectname: '',
      xmalimg: '',
      usbkeyimg: '',
      maile: '',
      companytitle: '',
      notice: '',
      imgurlas: '',
      refunddata: {},
      configdata: {},
      orderid:'',
      OrderType:'',
      companyinfo:'',
      Invoicerequeststatus:false,
      ruleForm:{
        "orderid": "",
        "subject": "",
        "yscode": "",
        "name": "",
        "phone": "",
        "email": "",
      },
      rules: {
        subject:[
          { required: true, message: '请输入单位名称', trigger: 'blur' },
          { min: 5, message: '长度不能小于5位数', trigger: 'blur' }
        ],
        yscode:[
          { required: true, message: '请输入信用代码（税号）', trigger: 'blur' },
          { min: 10, message: '长度不能小于10位数', trigger: 'blur' }
        ],
        name:[
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { min: 2, message: '请检查联系人姓名是否有误', trigger: 'blur' }
        ],
        phone:[
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在 11个字符', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    activeMenu(newVal) {
      if (newVal === 'order') {
        this.getlist();
      }
      if (newVal === 'invoice') {
        this.getInvoiceTitleList();
      }
      if (newVal === 'record') {
        this.getInvoiceRecordList();
      }
    }
  },
  created() {
    // /prod/
    this.actionurl = '/prod/api/order/uploadCertificate'
    // this.actionurl = 'http://192.168.21.132:8092/api/order/uploadCertificate'
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
    getInfo({}).then(response => {
      this.yscode = response.user.yscode
      this.orgcode = response.user.orgcode
      this.companyinfo = response.user
      this.getlist()
      this.getInvoiceTitleList()
    })
  },
  methods: {
    ClickreviewdialogVisible(row){
      this.reviewdialogVisible = true
      this.reviewdialogVisibletext = row.billmsg
    },
    // ========== 发票抬头相关方法 ==========
    // 获取发票抬头列表
    getInvoiceTitleList() {
      this.invoiceTitleLoading = true;
      invoiceTitle_selectlist({userid:this.companyinfo.userId}).then(response => {
        this.invoiceTitleList = response.data.data || [];
        this.invoiceTitleLoading = false;
      }).catch(() => {
        this.invoiceTitleLoading = false;
      });
    },
    // 显示新增弹窗
    showAddInvoiceTitle() {
      this.invoiceTitleModalTitle = '新增发票抬头';
      this.invoiceTitleForm = {
        id: null,
        subject: '',
        yscode: '',
        email: '',
        phone: '',
        address: '',
        bank: '',
        bankNum: ''
      };
      this.companySearchOptions = [];
      this.companySearchList = [];
      this.invoiceTitleModalVisible = true;
    },
    // 显示编辑弹窗
    editInvoiceTitle(row) {
      this.invoiceTitleModalTitle = '编辑发票抬头';
      this.invoiceTitleForm = {
        id: row.id,
        subject: row.subject,
        yscode: row.yscode,
        email: row.email,
        phone: row.phone,
        address: row.address || '',
        bank: row.bank || '',
        bankNum: row.bankNum || ''
      };
      this.companySearchOptions = [];
      this.companySearchList = [];
      this.invoiceTitleModalVisible = true;
    },
    // 提交表单
    submitInvoiceTitle() {
      this.$refs.invoiceTitleForm.validate(valid => {
        if (valid) {
          this.invoiceTitleSubmitting = true;
          const api = this.invoiceTitleForm.id ? invoiceTitle_update : invoiceTitle_add;
          api(this.invoiceTitleForm).then(response => {
            this.$message.success(this.invoiceTitleForm.id ? '修改成功' : '添加成功');
            this.invoiceTitleSubmitting = false;
            this.invoiceTitleModalVisible = false;
            this.getInvoiceTitleList();
          }).catch(() => {
            this.invoiceTitleSubmitting = false;
          });
        }
      });
    },
    // 删除发票抬头
    deleteInvoiceTitle(row) {
      this.$confirm('确定删除该发票抬头吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        invoiceTitle_delete({ id: row.id }).then(() => {
          this.$message.success('删除成功');
          this.getInvoiceTitleList();
        });
      }).catch(() => {});
    },
    // 单位名称搜索
    handleCompanySearch(queryString, cb) {
      if (!queryString || queryString.trim() === '') {
        cb([]);
        return;
      }
      company_search({ companytitle: queryString.trim(), yscode: '' }).then(response => {
        if (response.data && response.data.result) {
          const list = response.data.result || [];
          this.companySearchList = list;
          const results = list.map(item => ({
            value: item.name,
            name: item.name,
            taxId: item.taxId,
            location: item.location,
            bank: item.bank,
            bankAccount: item.bankAccount,
            mobilePhone: item.mobilePhone,
            fixedPhone: item.fixedPhone
          }));
          cb(results);
        } else {
          this.companySearchList = [];
          cb([]);
        }
      }).catch(() => {
        this.companySearchList = [];
        cb([]);
      });
    },
    // 用户手动修改单位名称时，清除自动填充的字段
    handleCompanyBlur() {
      if (this.companySearchList.length > 0) {
        const matched = this.companySearchList.find(c => c.name === this.invoiceTitleForm.subject);
        if (!matched) {
          this.invoiceTitleForm.yscode = '';
          this.invoiceTitleForm.address = '';
          this.invoiceTitleForm.bank = '';
          this.invoiceTitleForm.bankNum = '';
          this.invoiceTitleForm.phone = '';
        }
      }
    },
    // 选择单位后自动填充表单
    handleCompanySelect(item) {
      const selected = this.companySearchList.find(c => c.name === item.name);
      if (selected) {
        this.invoiceTitleForm.subject = selected.name || '';
        this.invoiceTitleForm.yscode = selected.taxId || '';
        this.invoiceTitleForm.address = selected.location || '';
        this.invoiceTitleForm.bank = selected.bank || '';
        this.invoiceTitleForm.bankNum = selected.bankAccount || '';
        this.invoiceTitleForm.phone = selected.mobilePhone || selected.fixedPhone || '';
      }
    },

    // ========== 开票记录相关方法 ==========
    // 获取开票记录列表
    getInvoiceRecordList() {
      this.invoiceRecordLoading = true;
      orderInvoice_selectlist({
        page: this.invoiceRecordPage,
        pagesize: this.invoiceRecordPageSize,
        userid:this.companyinfo.userId
      }).then(response => {
        this.invoiceRecordList = response.data.data || [];
        this.invoiceRecordTotal = response.data.total || 0;
        this.invoiceRecordLoading = false;
      }).catch(() => {
        this.invoiceRecordLoading = false;
      });
    },
    // 开票记录分页切换
    handleInvoiceRecordPageChange(page) {
      this.invoiceRecordPage = page;
      this.getInvoiceRecordList();
    },
    // 点击开票按钮 - 从开票记录页面，先选择订单
    clickshowAddInvoiceTitle() {
      this.invoicestatus = true;
      this.selectedOrderKeys = [];
      this.getPaidOrderList();
    },
    // 获取已支付的订单列表（用于开票选择）
    getPaidOrderList() {
      this.loading = true;
      mallOrderdata_selectlist({
        pagesize: 100,
        page: 1,
        status: 2, // 已支付
        drawer: 1,
        orgcode: this.orgcode,
        userid: this.companyinfo.userId,
        billstatus:2
      }).then(response => {
        this.sdatas = response.data.data || [];
        this.pagination.total = response.data.total || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 订单选择变化
    onSelectOrderChange(selectedRowKeys) {
      this.selectedOrderKeys = selectedRowKeys;
    },
    // 打开申请开票弹窗（选择订单后）
    // type: 0-单个订单(从行内点击), 1-多个订单(从选择弹窗点击)
    invoice(record, type) {
      if (type === 0) {
        // 单个订单开票 - 从表格行内点击
        this.selectedOrderIds = [record.id];
      } else {
        // 多个订单开票 - 从选择弹窗点击
        if (this.selectedOrderKeys.length === 0) {
          this.$message.warning('请选择要开票的订单');
          return;
        }
        this.selectedOrderIds = [...this.selectedOrderKeys];
      }
      // 关闭订单选择弹窗
      this.invoicestatus = false;
      // 打开申请开票弹窗
      this.invoiceModalVisible = true;
      this.selectedInvoiceTitleId = null;
      this.invoiceType = 1;
      this.getInvoiceTitleList();
    },
    // 查看开票记录详情
    editInvoiceRecordlook(row) {
      console.log(row,'row+++++++')
      this.invoiceRecordDetail = { ...row };
      this.invoiceRecordDetailVisible = true;
      // 加载关联订单
      this.loadInvoiceRecordOrders(row.orderids);
    },
    // 加载开票记录关联的订单
    loadInvoiceRecordOrders(iccids) {
      // mallOrderdata/selectlist
      mallOrderdata_selectlist({
        appid:'card_shengtang',
        pagesize: 100,
        page: 1,
        iccids:iccids,
        ordertypes:"5,6",
        userid:this.companyinfo.userId,
      }).then(response => {
        this.invoiceRecordDetailOrders = response.data.data || [];
        // this.invoiceRecordDetailOrders = orders.filter(order => orderIdArray.includes(order.id));
      });
    },
    // 删除开票记录
    deleteInvoiceRecord(row) {
      this.$confirm('确定删除该开票记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderInvoice_delete({ id: row.id }).then(() => {
          this.$message.success('删除成功');
          this.getInvoiceRecordList();
        });
      }).catch(() => {});
    },
    // 提交开票申请
    submitInvoice() {
      if (!this.selectedInvoiceTitleId) {
        this.$message.warning('请选择发票抬头');
        return;
      }
      // 找到选中的发票抬头信息
      const selectedTitle = this.invoiceTitleList.find(item => item.id === this.selectedInvoiceTitleId);
      if (!selectedTitle) {
        this.$message.warning('发票抬头信息不存在');
        return;
      }
      this.invoiceModalLoading = true;
      const params = {
        appid:'card_shengtang',
        header: selectedTitle.subject,
        yscode: selectedTitle.yscode,
        email: selectedTitle.email,
        address: selectedTitle.address,
        bank: selectedTitle.bank,
        bankNum: selectedTitle.bankNum,
        phone: selectedTitle.phone,
        invoiceType: this.invoiceType,
        orderids: this.selectedOrderIds.join(',')
      };
      orderInvoice_add(params).then(() => {
        this.$message.success('开票申请提交成功');
        this.invoiceModalLoading = false;
        this.invoiceModalVisible = false;
        this.getInvoiceRecordList();
        this.activeMenu = 'record';
      }).catch(() => {
        this.invoiceModalLoading = false;
      });
    },

    getlist() {
      this.listLoading = true
      this.listQuery.orgcode = this.orgcode
      this.listQuery.userid = this.companyinfo.userId
      mallOrderdata_selectlist(this.listQuery).then(response => {
          for(var i = 0;i<response.data.data.length;i++) {
            if( response.data.data[i].iccids != null) {
              var num = response.data.data[i].iccids.split(',')
              response.data.data[i].iccidsnum = num.length
            }
          }

        this.getlisdatas = response.data.data
        this.total = response.data.total
      })
    },
    handleClose(tab, event) {
    },
    // 条码弹窗点击x或者蒙版关闭
    testCodeChange() {
      this.randomOrderNo(); // 刷新订单号
    },
    barCodeChange(value) {
      this.authCode = value;
      this.immediatelyPay();
    },
    // 刷新订单号
    randomOrderNo() {
      this.getlist()
      this.mchOrderNo =
          "M" +
          new Date().getTime() +
          Math.floor(Math.random() * (9999 - 1000) + 1000);
    },
    // 申请开票
    Invoicerequest(row){
      cardInvoice_CardInvoiceList({orderid:row.id}).then(response => {
        this.invoicelist = response.data.data
      })
      this.Invoicerequeststatus = true
      this.ruleForm.subject = row.company
      this.ruleForm.yscode = row.yscode
      this.ruleForm.name = row.name
      this.ruleForm.phone = row.phone
      this.ruleForm.email = row.email
      this.ruleForm.orderid = row.id
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.invoicelist.length != 0){
            this.$message.info('您已申请开具发票！请耐心等待');
            return false
          }else{
            cardInvoice_Add_cardInvoice(this.ruleForm).then(response => {
              this.Invoicerequeststatus = false
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getlist()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.Invoicerequeststatus = false
      this.$refs[formName].resetFields();
    },


    /**
     * 订单是否允许删除
     * 只有「没有支付成功」或「已退款成功」的订单可以删除：
     *   未支付成功：0 已取消/待上传、3 支付失败/审核失败、6 订单关闭
     *   已退款成功：5 已退款、8 退款成功、11 退款成功
     * 其余状态（1 支付中、2 支付/审核成功、4 已撤销、7 退款审核中、
     * 9/12 退款失败、10 退款中、13 退款关闭、14 待审核）都不允许删除
     */
    canDeleteOrder(row) {
      var status = Number(row.status)
      return [0, 3, 6, 5].indexOf(status) > -1
    },

    chakandetele(row){
      // 兜底校验：防止绕过按钮直接调用
      if (!this.canDeleteOrder(row)) {
        this.$message.warning('该订单已支付或退款尚未完成，不支持删除')
        return
      }
      this.$confirm('确定删除该订单吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
              // mallOrderdata_delete_mallOrderdata
            mallOrderdata_delete_mallOrderdata({id:row.id}).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getlist()
            })
          })
          .catch(() => {

          })
    },


    chakanLookstatus(row){
      var that = this
      that.orderinfo = row
      console.log(row,'++++++++11111111++++++++')
      that.dialogVisibleDetails = true
      that.invoicelist = []
      //查询发票信息
      if(row.status == 2 && row.paymethod == 2 || row.status == 2 && row.paymethod == 1){
        cardInvoice_CardInvoiceList({orderid:row.id}).then(response => {
          // console.log(response,'++++++++++++')
          var invoicelist = response.data.data
          if(invoicelist.length != 0){
            for(var i = 0;i<invoicelist.length;i++){
              invoicelist[i].img = ''
              invoicelist[i].imglist = []
            }
            that.invoicelist = invoicelist
            var rowUrl = invoicelist[0].url
            //查询发票详情
            if (rowUrl != null && rowUrl != '') {
              var imgurl = rowUrl
              miniodownload(imgurl).then(response => {
                const blobObj = new Blob([response.data], { type: "application/x-download"});
                var previewUrl = URL.createObjectURL(blobObj);
                this.invoicelist[0].img = previewUrl
                this.invoicelist[0].imglist.push(previewUrl)
              })
            }
          }
        })
      }
      if(row.ordertype == 5){
        card_selectlist({iccids:that.orderinfo.iccids}).then(response => {
          this.datas = response.data.data
        })
      }else if(row.ordertype == 6){
        terminal_selectlist({sns:that.orderinfo.iccids}).then(response => {
          this.datas = response.data.data
        })
      }

      if(row.paymethod == 2 && row.paymentvoucher != ''){
        var imgurl = row.paymentvoucher
        var imgurlflow = imgurl.substring(imgurl.lastIndexOf("/")+1, imgurl.length)
        this.srcList = []
        mallOrderdata_download_seal(imgurlflow).then(response => {
          var previewUrl = URL.createObjectURL(response);
          this.srcList.push(previewUrl)
          this.dakuanimgurl = previewUrl
        })
      }
    },
    // 下载发票
    Downloadinvoice(row,index) {
      var that = this
      if (row.url == null || row.url == '') {
        this.$message.info('发票还未开出！请耐心等待');
        return false
      } else {
        var imgurl = row.url
        miniodownload(imgurl).then(response => {
          const blobObj = new Blob([response.data], { type: "application/x-download"});
          var previewUrl = URL.createObjectURL(blobObj);
          this.invoicelist[index].img = previewUrl
          this.invoicelist[index].imglist.push(previewUrl)

        })
      }
    },
    Downloadinvoicexiazai(row){
      var imgurl = row.url
      miniodownload(imgurl).then(response => {
        var fileName = row.url.substring(row.url.lastIndexOf("/")+1, row.url.length)
        const blobObj = new Blob([response.data], { type: "application/x-download"});

        // 创建下载链接元素
        const downloadLink = document.createElement("a");

        // 处理不同浏览器的 URL 兼容性
        let url = window.URL || window.webkitURL;
        url = url.createObjectURL(blobObj); // 创建文件 URL

        // 设置下载链接属性
        downloadLink.href = url;
        downloadLink.download = fileName;

        // 将下载链接添加到文档中并触发点击事件
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // 移除下载链接并释放 URL 对象
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);

      })
    },
    downloadBinaryFile(binFile, fileName, blobType,index) {
      // 创建 Blob 对象，包含二进制文件流和文件类型  text/plain  "image/"+blobType   application/x-download
      const blobObj = new Blob([binFile], { type: "application/x-download"});
      var previewUrl = URL.createObjectURL(blobObj);
      this.invoicelist[index].img = previewUrl
      this.invoicelist[index].imglist.push(previewUrl)

      // 创建下载链接元素
      const downloadLink = document.createElement("a");

      // 处理不同浏览器的 URL 兼容性
      let url = window.URL || window.webkitURL;
      url = url.createObjectURL(blobObj); // 创建文件 URL

      // 设置下载链接属性
      downloadLink.href = url;
      downloadLink.download = fileName;

      // 将下载链接添加到文档中并触发点击事件
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // 移除下载链接并释放 URL 对象
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    },



          // var previewUrl = URL.createObjectURL(response);
          // // this.srcList.push(previewUrl)
          // // this.dakuanimgurl = previewUrl
          // that.invoicelist[index].img = previewUrl
          // that.invoicelist[index].imglist.push(previewUrl)
            // }
    // 通用下载方法
    download (data, fileName) {
      const contentType = response.headers['content-type'];
      const blob = new Blob([data], { type: contentType });
      const link = document.createElement('a');
      link.href = blob;
      link.download = '发票.pdf'; // 可根据实际情况设置文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    homepay() {
      this.$router.push('/');
    },
    handleSubmits() {
      this.$router.push('/');
    },
    payTestShow() {
      // 如果未选择appid，或者支付方式列表为0，则不显示支付体验板块
      if (this.appId === "" || this.appPaywayList.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    // 此处判断，微信，支付宝，聚合码，哪种支付方式一个都没配置，如果未配置，则不显示该板块，若等于-1 则表示不存在
    showTitle(parameterA) {
      if (this.appPaywayList.toString().indexOf(parameterA) === -1) {
        return false;
      } else {
        return true;
      }
    },
    // showModal(e) {
    //   // mallOrderdata/getrestnum
    //   mallOrderdata_getrestnum({id: e}).then(response => {
    //     this.refunddata = response.data
    //     this.Id = e
    //     this.textarea = ''
    //     this.visible = true;
    //   })
    // },
    showKuaidi(row){
      this.expressno = row.expressno//row.expressno
      SF_query_by_expressno({expressno:row.expressno}).then((response) => {
        this.activities = response.data.routes
        if(response.data.routes.length == []){
          this.dialogVisible = false
          this.$message.info('暂无快递信息');
        }else{
          this.dialogVisible = true
        }
      });

    },
    handleTableChange(e) {
      this.page = e.current
      this.pagination.current = e.current
      order_orderlist({
        phone: this.phone,
        yscode: this.yscode,
        page: this.page,
        pagesize: this.pagesize,
      }).then(response => {
        this.datas = response.data.data
        this.pagination.total = response.data.total
      })

    },
    editinfo(){
      this.$router.push('/userinfo');
    },
    changepwd(){
      this.$router.push('/userinfo');
    },
    logout() {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeToken()
            localStorage.removeItem("Index");
            localStorage.removeItem("setToken");
            localStorage.removeItem("configdata");
            localStorage.removeItem("companyinfo");
            this.$router.push("/")
          })
          .catch(() => {

          })
    },

    handleOk(e) {
      switch (this.refunddata.statecode) {
          //证书系统未查询到此订单
        case 404:
          this.$message.info(this.refunddata.message);
          return false
          break;
          //证书系统查询到此订单已经全部消费完
        case 405:
          this.$message.info(this.refunddata.reason);
          return false
          break;
        case 0:
          if (this.textarea == '') {
            this.$message.info('退款原因不能为空！');
            return false
          } else {
            // mallOrderdata/apply_refund
            // mallOrderdata_apply_refund
            mallOrderdata_apply_refund({
              id: this.Id,
              refundmessage: this.textarea,
              // phone: this.phone,
              // yscode: this.yscode,
              // page: this.page,
              // pagesize: this.pagesize,
            }).then(response => {
              if (response.code == 0) {
                this.$message.info('信息提交成功');
                this.textarea = ''
                this.visible = false;
                order_orderlist({
                  phone: this.phone,
                  yscode: this.yscode,
                  page: this.page,
                  pagesize: this.pagesize,
                }).then(response => {
                  this.datas = response.data.data
                  this.pagination.total = response.data.total
                })
              }
            })
          }
          break;
      }
    },
    handleCancel(e) {
      this.textarea = ''
      this.visible = false;
    },
    updataphone(id){
      this.updatedata.id = id
    },


    handleuploadSuccess(res, file) {
      if(res.code == '404'){
        this.fileList = []
        this.$message.error(res.message);
        return false
      }
      this.dialogVisibleDetails = false
      this.fileList = []
      this.$message({
        message: '文件上传成功！',
        type: 'success'
      });
      this.getlist()

    },
    beforeupload(file) {
      const fileLimit = file.size / 1024 / 1024 < 2;
      if(!fileLimit) {
        this.$message.error('请上传文件大小不得超过2MB图片！');
      }
      return fileLimit;
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择1个文件`);
    },
    chongxinhandleuploadSuccess(res, file) {
      if(res.code == '404'){
        this.fileList = []
        this.$message.error(res.message);
        return false
      }
      this.fileList = []
      this.$message({
        message: '文件上传成功！',
        type: 'success'
      });
      mallOrderdata_deal_seal_list({orderid:this.orderid}).then(response => {
        this.phonelist = response.data.data
      })
    },
    chongxinbeforeupload(file) {
      const fileLimit = file.size / 1024 / 1024 < 2;
      if(!fileLimit) {
        this.$message.error('请上传文件大小不得超过2MB图片！');
      }
      return fileLimit;
    },
    chongxinhandleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择1个文件`);
    },

    // 查看发票 PDF
    viewInvoicePdf(record) {
      const orderId = record.id
      if (!orderId) {
        this.$message.warning('订单ID不存在')
        return
      }
      invoice_query({ orderId: orderId }).then(response => {
        if (response.data && response.data.pdfUrl) {
          this.invoicePdfUrl = response.data.pdfUrl
          this.invoicePdfVisible = true
        } else {
          this.$message.info('暂无发票文件')
        }
      }).catch(() => {
        this.$message.error('查询发票失败')
      })
    },
    // 通过订单查看发票（开票记录详情弹窗中关联订单使用）
    viewInvoicePdfByOrder(record) {
      const orderId = record.id
      if (!orderId) {
        this.$message.warning('订单ID不存在')
        return
      }
      invoice_query({ orderId: orderId }).then(response => {
        if (response.data && response.data.pdfUrl) {
          this.invoicePdfUrl = response.data.pdfUrl
          this.invoicePdfVisible = true
        } else {
          this.$message.info('暂无发票文件')
        }
      }).catch(() => {
        this.$message.error('查询发票失败')
      })
    },
    // 关闭发票 PDF 弹窗
    closeInvoicePdf() {
      this.invoicePdfVisible = false
      this.invoicePdfUrl = ''
    },
    // 下载发票 PDF
    downloadInvoicePdf() {
      if (this.invoicePdfUrl) {
        const link = document.createElement('a')
        link.href = this.invoicePdfUrl
        link.download = '发票.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    // 生成合同（调用 order/applyContract）
    generateAcontract(row) {
      if (!row || !row.id) {
        this.$message.warning('订单数据异常，无法生成合同')
        return
      }
      order_applyContract({ orderId: row.id }).then(response => {
        this.$message.success('合同生成成功')
        this.getlist() // 刷新订单列表
      }).catch(() => {
        this.$message.error('合同生成失败')
      })
    },
    // 预览合同（minio/download 取流 → 内嵌弹窗 iframe 预览）
    previewContract(row) {
      if (!row.sealUrl) {
        this.$message.info('暂无合同文件')
        return
      }
      this.contractPreviewLoading = true
      this.contractPreviewVisible = true
      this.contractPreviewUrl = ''
      this.contractFileName = (row.company || '合同') + '_合同' + this.getFileExt(row.sealUrl)
      const that = this
      miniodownload(row.sealUrl).then(response => {
        // 按文件扩展名确定 MIME，保证 iframe 能内嵌渲染 PDF
        const ext = this.getFileExt(row.sealUrl).toLowerCase()
        let mimeType = 'application/x-download'
        if (ext === '.pdf') {
          mimeType = 'application/pdf'
        } else if (ext === '.jpg' || ext === '.jpeg') {
          mimeType = 'image/jpeg'
        } else if (ext === '.png') {
          mimeType = 'image/png'
        } else if (ext === '.gif') {
          mimeType = 'image/gif'
        }
        const blobObj = new Blob([response.data], { type: mimeType });
        that.contractPreviewUrl = URL.createObjectURL(blobObj)
        that.contractPreviewLoading = false
      }).catch(() => {
        that.contractPreviewLoading = false
        that.contractPreviewVisible = false
        that.$message.error('合同文件加载失败')
      })
    },
    // 关闭合同预览弹窗
    closeContractPreview() {
      this.contractPreviewVisible = false
      this.contractPreviewUrl = ''
      this.contractPreviewLoading = false
    },
    // 获取文件扩展名（用于下载命名）
    getFileExt(url) {
      if (!url) return '.pdf'
      // 处理 query 参数，取路径最后一段
      const path = url.split('?')[0]
      const match = path.match(/\.([a-zA-Z0-9]+)$/)
      return match ? '.' + match[1] : '.pdf'
    },
    // 下载合同（操作栏）— 走 minio/download 取流
    downloadContract(row) {
      if (!row.sealUrl) {
        this.$message.info('暂无合同文件')
        return
      }
      const fileName = (row.company || '合同') + '_合同' + this.getFileExt(row.sealUrl)
      miniodownload(row.sealUrl).then(response => {
        const blobObj = new Blob([response.data], { type: "application/x-download"});
        // 创建下载链接元素
        const downloadLink = document.createElement("a");
        // 处理不同浏览器的 URL 兼容性
        let url = window.URL || window.webkitURL;
        url = url.createObjectURL(blobObj); // 创建文件 URL
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
      }).catch(() => {
        this.$message.error('合同下载失败')
      })
    },
    // 下载合同（预览弹窗内）— contractPreviewUrl 已为 minio 转出的 blob 地址
    downloadContractByUrl() {
      if (this.contractPreviewUrl) {
        const link = document.createElement('a')
        link.href = this.contractPreviewUrl
        link.download = this.contractFileName || '合同'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },

  }
}
</script>

<style lang="css" scoped>
@import './payTest.css';

b {
  color: #333;
}

#box {
  display: block;
  width: 100%;
  overflow: hidden;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed; /* 背景图片固定 */
  min-height: 100vh; /* 至少为视口高度 */
  padding-bottom:20px;
  box-sizing: border-box;
}

.financeitem{padding: 5px;border-bottom: #ccc dashed 1px;}
#leftbar {
  display: flex;
  flex-direction: row;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/*box_info*/

.box_info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 用户信息卡片样式 */
.user-info-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
  border-radius: 12px;
  padding: 20px 30px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #ebeef5;
}

.user-info-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-avatar {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.user-company {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e4e7ed;
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-company::before {
  content: '';
  width: 4px;
  height: 20px;
  background: linear-gradient(180deg, #f56c6c 0%, #e53935 100%);
  border-radius: 2px;
}

.user-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  background: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.meta-item i {
  font-size: 14px;
}

.meta-yscode i {
  color: #e53935;
}

.meta-phone i {
  color: #f56c6c;
}

.meta-label {
  color: #909399;
  font-size: 12px;
  margin-right: 4px;
  border-right: 1px solid #e4e7ed;
  padding-right: 6px;
}

.meta-value {
  color: #303133;
  font-weight: 500;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
}

.user-actions {
  display: flex;
  gap: 12px;
}

.btn-edit {
  background: #fff;
  border: 1px solid #f56c6c;
  color: #f56c6c;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-edit:hover {
  background: #f56c6c;
  color: #fff;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.btn-logout {
  background: #fff;
  border: 1px solid #f56c6c;
  color: #f56c6c;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-logout:hover {
  background: #f56c6c;
  color: #fff;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

/* 新增按钮样式 */
.btn-add-title {
  position: absolute;
  right: 20px;
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  border-color: #f56c6c;
}

.btn-add-title:hover {
  background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
  border-color: #e53935;
}

/* 左侧菜单 + 内容区布局 */
.main-layout {
  display: flex;
  gap: 20px;
  min-height: 600px;
}

.sidebar-menu {
  width: 200px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  padding: 16px 0;
  height: fit-content;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px 16px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
  font-size: 16px;
  font-weight: 600;
  color: #f56c6c;
}

.menu-header i {
  font-size: 18px;
  color: #f56c6c;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  margin: 4px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #606266;
}

.menu-item:hover {
  background: #fef0f0;
  color: #f56c6c;
}

.menu-item.active {
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.menu-item i {
  font-size: 16px;
}

.content-area {
  flex: 1;
  min-width: 0;
}

.content-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  border-bottom: 1px solid #f5c6c6;
  font-size: 16px;
  font-weight: 600;
  color: #c0392b;
  position: relative;
}

.section-header i {
  font-size: 18px;
  color: #f56c6c;
}

.section-body {
  padding: 0;
}

.invoice-body {
  padding: 20px;
  min-height: 400px;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
}

.placeholder-content i {
  font-size: 64px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.placeholder-content p {
  font-size: 16px;
  margin: 0;
}

.box_list{
  display: flex;
  flex-direction: row;
  height: 40px;
  line-height: 40px;
}

.userinfo{
  display: none;
}

.userinfo_bottom_list{
  display: none;
}

.order_title{
  display: none;
}

span{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}


/* 左侧菜单 + 内容区布局 */
.main-layout {
  display: flex;
  gap: 20px;
  min-height: 600px;
}

.sidebar-menu {
  width: 200px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  padding: 16px 0;
  height: fit-content;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px 16px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
  font-size: 16px;
  font-weight: 600;
  color: #f56c6c;
}

.menu-header i {
  font-size: 18px;
  color: #f56c6c;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  margin: 4px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #606266;
}

.menu-item:hover {
  background: #fef0f0;
  color: #f56c6c;
}

.menu-item.active {
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.menu-item i {
  font-size: 16px;
}

.content-area {
  flex: 1;
  min-width: 0;
}

.content-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  border-bottom: 1px solid #f5c6c6;
  font-size: 16px;
  font-weight: 600;
  color: #c0392b;
  position: relative;
}

.section-header i {
  font-size: 18px;
  color: #f56c6c;
}

/* 发票信息样式 */
.invoice-content {
  padding: 60px 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invoice-empty {
  text-align: center;
  color: #909399;
}

.invoice-empty i {
  font-size: 64px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.invoice-empty p {
  font-size: 16px;
  margin-bottom: 8px;
  color: #606266;
}

.invoice-empty span {
  font-size: 13px;
  color: #909399;
}

/* 发票信息主体 */
.invoice-body {
  padding: 20px;
}

/* 发票抬头信息 */
.invoice-header-info {
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #f5c6c6;
}

.info-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #c0392b;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f5c6c6;
}

.info-title i {
  font-size: 18px;
}

.info-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-label {
  color: #666;
  font-size: 14px;
  min-width: 100px;
}

.info-value {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

/* 开票记录 */
.invoice-records {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.records-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #fafafa;
  border-bottom: 1px solid #e4e7ed;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.records-title i {
  color: #f56c6c;
  font-size: 16px;
}

.records-count {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
  font-weight: normal;
}

.records-table-wrapper {
  padding: 16px;
}

.records-table {
  margin-bottom: 0;
}

.records-table .ant-table-thead > tr > th {
  background: #fef0f0;
  color: #c0392b;
  font-weight: 600;
}

.records-empty {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.records-empty i {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 12px;
}

.records-empty p {
  font-size: 14px;
  margin: 0;
}

/* 发票抬头列表样式 */
.section-title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fafafa;
  border-bottom: 1px solid #e4e7ed;
}

.title-count {
  font-size: 13px;
  color: #909399;
}

.btn-add-title {
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  border-color: #f56c6c;
  position: absolute;
  right: 25px;
}

.btn-add-title:hover {
  background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
  border-color: #e53935;
}

.title-table-wrapper {
  padding: 16px;
}

.title-table .ant-table-thead > tr > th {
  background: #fef0f0;
  color: #c0392b;
  font-weight: 600;
}

/* 弹窗样式优化 */
.ant-modal-header {
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  border-bottom: 1px solid #f5c6c6;
}

.ant-modal-title {
  color: #c0392b;
  font-weight: 600;
}

/* 状态标签样式 */
.status-sent {
  color: #67c23a;
  font-weight: 500;
}

.status-processing {
  color: #e6a23c;
  font-weight: 500;
}

.status-failed {
  color: #f56c6c;
  font-weight: 500;
}

/* 开票弹框样式 */
.invoice-order-info {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.invoice-order-info h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 15px;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 8px;
}

.invoice-order-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

.invoice-order-info p span {
  color: #999;
  margin-right: 8px;
}

.invoice-title-select h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 15px;
}

/* 发票抬头卡片样式 - 简化版 */
.invoice-title-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.invoice-title-radio-group .ant-radio-wrapper {
  margin-right: 0;
}

.invoice-title-simple-card {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s;
  cursor: pointer;
  min-height: 56px;
}

.invoice-title-simple-card:hover {
  border-color: #f56c6c;
}

.invoice-title-simple-card.ant-radio-wrapper-checked {
  border: 2px solid #f56c6c;
  background: #fef0f0;
}

.invoice-title-simple-card .ant-radio {
  margin-right: 16px;
}

/* 选中时radio按钮变红色 */
.invoice-title-simple-card .ant-radio-checked .ant-radio-inner {
  border-color: #f56c6c !important;
}

.invoice-title-simple-card .ant-radio-checked .ant-radio-inner:after {
  background-color: #f56c6c !important;
}

.invoice-title-simple-card.ant-radio-wrapper-checked .ant-radio {
  color: #f56c6c !important;
}

.invoice-title-simple-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 发票类型选择样式 */
.invoice-type-select {
  margin-bottom: 16px;
}

.invoice-type-select h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 15px;
}

.invoice-type-radio-group {
  display: flex;
  gap: 20px;
}

.invoice-type-radio-group .ant-radio-wrapper {
  font-size: 14px;
}

/* 发票类型选中时radio变红色 */
.invoice-type-radio-group .ant-radio-checked .ant-radio-inner {
  border-color: #f56c6c !important;
}

.invoice-type-radio-group .ant-radio-checked .ant-radio-inner:after {
  background-color: #f56c6c !important;
}

/* 开票记录表格样式 */
.records-table .ant-tag {
  font-size: 12px;
  padding: 2px 8px;
}

/* 文字省略样式 */
.ellipsis-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

/* 开票记录详情弹框样式 */
.invoice-info-section {
  padding: 10px 0;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #f56c6c;
}

.info-row {
  margin-bottom: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.info-label {
  color: #666;
  min-width: 80px;
}

.info-value {
  color: #333;
  font-weight: 500;
}

.order-list-section {
  padding: 10px 0;
}

.ant-radio-checked .ant-radio-inner {
  background-color: red !important; /* 例如：#1DA57A */
  border-color: red !important; /* 例如：#1DA57A */
}

/* 开票弹窗样式 */
.invoice-section {
  margin-bottom: 24px;
}

.section-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-subtitle i {
  color: #f56c6c;
  font-size: 16px;
}

.invoice-title-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.invoice-title-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  transition: all 0.3s;
  margin-right: 0;
}

.invoice-title-item:hover {
  border-color: #f56c6c;
  background: #fef0f0;
}

.invoice-title-item.is-checked {
  border-color: #f56c6c;
  background: #fef0f0;
}

.invoice-title-item .el-radio__input.is-checked .el-radio__inner {
  border-color: #f56c6c;
  background: #f56c6c;
}

.invoice-title-item .el-radio__input.is-checked + .el-radio__label {
  color: #f56c6c;
}

.title-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
}

.title-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.title-code {
  font-size: 12px;
  color: #909399;
  font-family: 'Courier New', monospace;
}

.empty-tips {
  padding: 20px;
  text-align: center;
  color: #909399;
  background: #f5f7fa;
  border-radius: 8px;
}

.empty-tips i {
  color: #f56c6c;
  margin-right: 4px;
}

/* 分页样式 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
  background: #fff;
}

/* 已选订单样式 */
.selected-orders {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
  max-height: 120px;
  overflow-y: auto;
}

.order-tag {
  display: flex;
  align-items: center;
}

.order-tag .el-tag {
  background: #fff;
  border-color: #e4e7ed;
  color: #606266;
}

/* 开票记录详情弹窗样式 */
.invoice-detail-dialog .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  padding: 20px;
}

.invoice-detail-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.invoice-detail-dialog .el-dialog__body {
  padding: 20px;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.section-line {
  width: 4px;
  height: 18px;
  background: linear-gradient(180deg, #f56c6c 0%, #e53935 100%);
  border-radius: 2px;
  margin-right: 10px;
}

.detail-info-content {
  padding: 0 10px;
}

.detail-info-content .el-row {
  margin-bottom: 16px;
}

.detail-info-content .el-row:last-child {
  margin-bottom: 0;
}

.info-row {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.info-label {
  color: #909399;
  font-size: 14px;
  white-space: nowrap;
}

.info-value {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
}

/* 发票 PDF 弹窗样式 */
.invoice-pdf-container {
  width: 100%;
  min-height: 600px;
  background: #f5f7fa;
  border-radius: 8px;
  overflow: hidden;
}

.invoice-pdf-container iframe {
  display: block;
  border: none;
}

.invoice-empty {
  text-align: center;
  padding: 100px 20px;
  color: #909399;
}

.invoice-empty i {
  font-size: 64px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.invoice-empty p {
  font-size: 16px;
}

.detail-table-content {
  padding: 0 10px;
}

.detail-table-content .el-table {
  border-radius: 4px;
}

.detail-table-content .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.invoice-detail-dialog .dialog-footer {
  text-align: right;
}

.invoice-detail-dialog .dialog-footer .el-button {
  min-width: 80px;
}

/* 单位名称搜索下拉样式 */
.company-search-item {
  padding: 4px 0;
}

.company-search-name {
  font-weight: 500;
  line-height: 22px;
  font-size: 14px;
  color: #303133;
}

.company-search-code {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.company-search-item .el-autocomplete-suggestion__list {
  padding: 4px 0;

}
</style>
